

<div class="login-container m-auto">
  <div class="card boxshadow">
    <div class="card-header bg-primary text-white d-flex justify-content-center align-items-center">
      <a class="btn" style="border: 1px solid; border-color: white;">
        Independent Corporate Distributors
      </a>

    </div> 

    <div class="card-body">
      <div class="row">

        <div class="col-md-4">
          <label class="form-label">Country</label>


          <ng-select [searchable]="true"
                     (change)="filterTableByStatus($event)">
            <ng-option *ngFor="let o of iDPReports"
                       [value]="o.value">
              {{ o.label }}
            </ng-option>
          </ng-select>



        </div>

        <div class="col-md-4">
          <label class="form-label">ICD Status</label>


          <ng-select [searchable]="true" [(ngModel)]="selectedICDStatus"
                     (change)="filterTableByStatusICD($event)">
            <ng-option *ngFor="let o of iDPICD"
                       [value]="o.value">
              {{ o.label }}
            </ng-option>
          </ng-select>



        </div>
        <div class="col-md-4">
          <label class="form-label">Location Status</label>


          <ng-select [searchable]="true" [(ngModel)]="selectedOfficeStatus"
                     (change)="filterTableByStatusOffice($event)">
            <ng-option *ngFor="let o of iDPOffice"
                       [value]="o.value">
              {{ o.label }}
            </ng-option>
          </ng-select>



        </div>
      </div>
      <div class="col-md-12">

        <div class="form-group">



          <div class="col-md-4 pull-right ">
            <a routerlink="/icd" class="btn btn-sm btn-success mb-2" ng-reflect-router-link="/icd" href="/icd">Add ICD</a>
          </div>



        </div>

        <table id="tbldata" datatable [dtOptions]="dtOptions" class="table  dt-responsive " style="width:100%">

          
          </table>

      </div>
      </div>
  </div>
</div>
